// Feature: product-media-video - start
(function () {
  var selector = "[data-product-media-video]";
  var initializedAttribute = "data-product-media-video-initialized";
  var activeVideo = null;

  function initProductMediaVideos(root) {
    var scope = root || document;
    var videos = [];

    if (scope.matches && scope.matches(selector)) {
      videos.push(scope);
    }

    videos = videos.concat(Array.prototype.slice.call(scope.querySelectorAll(selector)));

    videos.forEach(function (container) {
      if (container.hasAttribute(initializedAttribute)) {
        return;
      }

      container.setAttribute(initializedAttribute, "true");
      setupProductMediaVideo(container);
    });
  }

  function setupProductMediaVideo(container) {
    var video = container.querySelector("[data-product-media-video-element]");
    var toggle = container.querySelector("[data-product-media-video-toggle]");

    if (!video || !toggle) {
      return;
    }

    var hideTimer = null;
    var userPaused = false;
    var hasLoadedSources = video.querySelector("source[src]") !== null;
    var previousAutoplayEnabled = isAutoplayEnabled();

    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");

    container.classList.add("is-paused");

    syncMode();
    setupVisibilityObserver();
    setupHiddenStateObserver();
    setupModeObserver();

    toggle.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (video.paused) {
        userPaused = false;
        container.classList.remove("is-paused-by-user");
        playVideo({
          revealControls: true
        });
      } else {
        userPaused = true;
        container.classList.add("is-paused-by-user");
        pauseVideo();
      }
    });

    container.addEventListener("click", function (event) {
      if (event.target.closest("[data-product-media-video-toggle]")) {
        return;
      }

      if (video.paused) {
        setControlsVisible(true);
        return;
      }

      showControlsTemporarily();
    });

    video.addEventListener("play", function () {
      container.classList.add("is-playing");
      container.classList.remove("is-paused", "has-playback-error");
      updateToggleLabel(true);
      scheduleControlsHide();
    });

    video.addEventListener("pause", function () {
      container.classList.remove("is-playing", "is-loading");
      container.classList.add("is-paused");
      updateToggleLabel(false);

      if (!isAutoplayEnabled() || userPaused) {
        setControlsVisible(true);
      }
    });

    video.addEventListener("ended", function () {
      container.classList.remove("is-playing");
      container.classList.add("is-paused");
      setControlsVisible(true);
      updateToggleLabel(false);
    });

    document.addEventListener("visibilitychange", function () {
      if (document.hidden && !video.paused) {
        video.pause();
      }
    });

    function setupVisibilityObserver() {
      if (!("IntersectionObserver" in window)) {
        if (isAutoplayEnabled()) {
          setControlsVisible(true);
        }
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (isAutoplayEnabled() && !userPaused) {
              playVideo({
                revealControls: false
              });
            }
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, {
        threshold: 0.35
      });

      observer.observe(container);
    }

    function setupHiddenStateObserver() {
      if (!("MutationObserver" in window)) {
        return;
      }

      var mediaWrapper = container.closest("[data-product-media-wrapper]");

      if (!mediaWrapper) {
        return;
      }

      var observer = new MutationObserver(function () {
        if (mediaWrapper.classList.contains("hidden") && !video.paused) {
          video.pause();
        }
      });

      observer.observe(mediaWrapper, {
        attributes: true,
        attributeFilter: ["class"]
      });
    }

    function setupModeObserver() {
      if (!("MutationObserver" in window)) {
        return;
      }

      var observer = new MutationObserver(function () {
        syncMode();
      });

      observer.observe(container, {
        attributes: true,
        attributeFilter: ["data-video-autoplay"]
      });
    }

    function loadSources() {
      if (hasLoadedSources) {
        return;
      }

      Array.prototype.slice.call(video.querySelectorAll("source[data-src]")).forEach(function (source) {
        source.setAttribute("src", source.dataset.src);
        source.removeAttribute("data-src");
      });

      hasLoadedSources = true;
      video.load();
    }

    function playVideo(options) {
      var settings = options || {};
      var revealControls = settings.revealControls !== false;

      pauseOtherVideos(video);
      loadSources();

      container.classList.add("is-loading");
      setControlsVisible(revealControls);

      var playPromise = video.play();

      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(function () {
          container.classList.remove("is-loading", "is-playing");
          container.classList.add("is-paused", "has-playback-error");
          setControlsVisible(true);
          updateToggleLabel(false);
        });
      }
    }

    function pauseVideo() {
      video.pause();
      setControlsVisible(true);
    }

    function pauseOtherVideos(currentVideo) {
      if (activeVideo && activeVideo !== currentVideo) {
        activeVideo.pause();
      }

      activeVideo = currentVideo;

      Array.prototype.slice.call(document.querySelectorAll(selector + " video")).forEach(function (otherVideo) {
        if (otherVideo !== currentVideo && !otherVideo.paused) {
          otherVideo.pause();
        }
      });
    }

    function showControlsTemporarily() {
      setControlsVisible(true);
      scheduleControlsHide();
    }

    function scheduleControlsHide() {
      window.clearTimeout(hideTimer);

      if (video.paused) {
        return;
      }

      hideTimer = window.setTimeout(function () {
        setControlsVisible(false);
      }, 900);
    }

    function setControlsVisible(isVisible) {
      container.classList.toggle("is-control-visible", isVisible);
    }

    function isAutoplayEnabled() {
      return container.dataset.videoAutoplay === "true";
    }

    function syncMode() {
      var autoplayEnabled = isAutoplayEnabled();

      container.classList.toggle("is-autoplay-mode", autoplayEnabled);
      container.classList.toggle("product-media-video--autoplay", autoplayEnabled);

      if (!autoplayEnabled && previousAutoplayEnabled && !video.paused) {
        userPaused = true;
        container.classList.add("is-paused-by-user");
        pauseVideo();
      } else if (autoplayEnabled) {
        setControlsVisible(false);
      } else if (video.paused) {
        setControlsVisible(true);
      }

      previousAutoplayEnabled = autoplayEnabled;
    }

    function updateToggleLabel(isPlaying) {
      var playLabel = toggle.dataset.playLabel || "Play video";
      var pauseLabel = toggle.dataset.pauseLabel || "Pause";

      toggle.setAttribute("aria-label", isPlaying ? pauseLabel : playLabel);
      toggle.setAttribute("aria-pressed", isPlaying ? "true" : "false");
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initProductMediaVideos(document);
    });
  } else {
    initProductMediaVideos(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initProductMediaVideos(event.target);
  });
})();
// Feature: product-media-video - end
